import { render, staticRenderFns } from "./WeFixRepairCAHome.vue?vue&type=template&id=6f610a13&"
import script from "./WeFixRepairCAHome.vue?vue&type=script&lang=js&"
export * from "./WeFixRepairCAHome.vue?vue&type=script&lang=js&"
import style0 from "./WeFixRepairCAHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports